import { jsx } from 'react/jsx-runtime';
import { isOneOf } from '@flysas-tech/adg-toolbox';
import clsx from 'clsx';
import invariant from '../../utils/invariant.js';
import { TOKENS, paragraphStyles } from './paragraph.css.js';

const VARIANTS = Object.values(TOKENS.variant);
const WEIGHTS = [...Object.values(TOKENS.weight), undefined];
function Paragraph({
  capitalize,
  children,
  className,
  italic,
  uppercase,
  variant = TOKENS.variant.primary,
  weight,
  ...rest
}) {
  const classes = clsx(
    paragraphStyles({
      variant,
      weight,
      italic,
      uppercase,
      capitalize
    }),
    className
  );
  invariant(isOneOf(VARIANTS, variant), `The 'variant' prop must be one of '${VARIANTS}', but you passed '${variant}'`);
  invariant(isOneOf(WEIGHTS, weight), `The 'weight' prop must be one of '${WEIGHTS}', but you passed '${weight}'`);
  return /* @__PURE__ */ jsx("p", { className: classes, ...rest, children });
}

export { Paragraph, Paragraph as default, TOKENS as tokens };
